import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Box, Progress as Progress$1, Flex, Text, CircularProgress as CircularProgress$1, Spacer, CircularProgressLabel } from '@chakra-ui/react';
var _excluded = ["colorScheme", "hasStripe", "isAnimated", "min", "max", "size", "value", "variant", "labelPosition", "labelText"],
  _excluded2 = ["trackColor", "thickness", "min", "max", "shapeSize", "value", "colorScheme", "chakraProgressLabel"];
var Progress = function Progress(_ref) {
  var colorScheme = _ref.colorScheme,
    _ref$hasStripe = _ref.hasStripe,
    hasStripe = _ref$hasStripe === void 0 ? false : _ref$hasStripe,
    _ref$isAnimated = _ref.isAnimated,
    isAnimated = _ref$isAnimated === void 0 ? false : _ref$isAnimated,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    size = _ref.size,
    value = _ref.value;
  _ref.variant;
  var _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? 'top' : _ref$labelPosition,
    labelText = _ref.labelText,
    rest = _objectWithoutProperties(_ref, _excluded);
  /**
   * DOM
   */
  var labelData = /*#__PURE__*/React.createElement(Flex, {
    as: "header",
    p: 2,
    gap: 2,
    align: 'center'
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: 2,
    align: 'flex-start'
  }, /*#__PURE__*/React.createElement(Text, {
    as: "label"
  }, labelText)), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Flex, {
    gap: 2,
    align: 'flex-end'
  }, /*#__PURE__*/React.createElement(Text, {
    as: "label"
  }, value + '%')));
  if (labelPosition === 'top' || labelPosition === 'bottom') {
    return /*#__PURE__*/React.createElement(Box, null, labelPosition === 'top' && labelData, /*#__PURE__*/React.createElement(Progress$1, _extends({
      value: value,
      "data-object-type": "progress",
      size: size,
      colorScheme: colorScheme,
      hasStripe: hasStripe,
      isAnimated: isAnimated,
      min: min,
      max: max
    }, rest)), labelPosition === 'bottom' && labelData);
  }
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Flex, {
    gap: 1,
    align: "center"
  }, /*#__PURE__*/React.createElement(Progress$1, _extends({
    flex: "1 0 auto",
    value: value,
    "data-object-type": "progress",
    size: size,
    colorScheme: colorScheme,
    hasStripe: hasStripe,
    isAnimated: isAnimated,
    min: min,
    max: max
  }, rest)), /*#__PURE__*/React.createElement(Text, {
    as: "label",
    align: 'right'
  }, value + '%')));
};
Progress.displayName = "Progress";
var CircularProgress = function CircularProgress(_ref2) {
  var trackColor = _ref2.trackColor,
    thickness = _ref2.thickness,
    _ref2$min = _ref2.min,
    min = _ref2$min === void 0 ? 0 : _ref2$min,
    _ref2$max = _ref2.max,
    max = _ref2$max === void 0 ? 100 : _ref2$max,
    shapeSize = _ref2.shapeSize,
    value = _ref2.value,
    colorScheme = _ref2.colorScheme,
    _ref2$chakraProgressL = _ref2.chakraProgressLabel,
    chakraProgressLabel = _ref2$chakraProgressL === void 0 ? false : _ref2$chakraProgressL,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  /**
   * DOM
   */
  var label = chakraProgressLabel ? /*#__PURE__*/React.createElement(CircularProgressLabel, null, value + '%') : undefined;
  return /*#__PURE__*/React.createElement(CircularProgress$1, _extends({
    "data-object-type": "progress-circular",
    trackColor: trackColor,
    min: min,
    max: max,
    value: value,
    size: shapeSize,
    thickness: thickness,
    color: "".concat(colorScheme + '.500')
  }, rest), label);
};
CircularProgress.displayName = "CircularProgress";
export { CircularProgress, Progress };